const map = {
	"./91/Spectate/LeftHeader.pc.layout.js": [
		77855,
		[
			1111
		]
	],
	"./92/Spectate/LeftHeader.pc.layout.js": [
		56526,
		[
			6566
		]
	],
	"./94/Spectate/LeftHeader.pc.layout.js": [
		58788,
		[
			9636
		]
	],
	"./95/Spectate/LeftHeader.pc.layout.js": [
		6139,
		[
			535
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57596;
module.exports = webpackAsyncContext;